import React from "react";
import { Router } from "@reach/router";
import {
	LoginPage,
	ForgotPasswordPage,
	NewPasswordPage,
	DashboardPage,
	EditProfilePage
} from "pages";
import {
  AuthProvider,
	CustomerProvider,
} from "contexts";

import { NotificationsProvider, setUpNotifications } from 'reapop';
import { ThemeProvider } from "@mui/system";
import { muiTheme } from "theme/mui";

setUpNotifications({
	defaultProps: {
	  position: 'top-right',
	  dismissible: true,
	  dismissAfter: 5000
	} 
});

// temporarily fix Router type error
const BrowserRouter: any = Router;

function App() {
  // update document title each page
  // to update every time, when change pathname
	
  return (
    <div className="App">
		<NotificationsProvider>
			<AuthProvider>
				<CustomerProvider>
					<ThemeProvider theme={muiTheme}>
						<BrowserRouter>
							<LoginPage path="/" />
							<ForgotPasswordPage path="/forgot-password" />
							<NewPasswordPage path="/new-password" />
							<DashboardPage path="/dashboard" />
							<EditProfilePage path="/customer/edit/:id" />
						</BrowserRouter>
					</ThemeProvider>
				</CustomerProvider>
			</AuthProvider>
		</NotificationsProvider>
    </div>
  );
}

export default App;
